// Copyright 2024
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/resource/v1/user_invitation.proto (package msh.resource.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Language } from "../../common/v1/language_pb";
import { Agent } from "../../common/v1/common_pb";

/**
 * @generated from enum msh.resource.v1.InvitationStatus
 */
export const InvitationStatus = proto3.makeEnum(
  "msh.resource.v1.InvitationStatus",
  [
    {no: 0, name: "INVITATION_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "INVITATION_STATUS_PENDING", localName: "PENDING"},
    {no: 2, name: "INVITATION_STATUS_ACCEPTED", localName: "ACCEPTED"},
    {no: 3, name: "INVITATION_STATUS_REFUSED", localName: "REFUSED"},
  ],
);

/**
 * @generated from message msh.resource.v1.UserInvitation
 */
export const UserInvitation = proto3.makeMessageType(
  "msh.resource.v1.UserInvitation",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 5, name: "creation_time", kind: "message", T: Timestamp },
    { no: 6, name: "last_update_time", kind: "message", T: Timestamp },
    { no: 7, name: "expiration_time", kind: "message", T: Timestamp },
    { no: 8, name: "created_by", kind: "message", T: Agent },
    { no: 9, name: "status", kind: "enum", T: proto3.getEnumType(InvitationStatus) },
  ],
);

